module.exports = __webpack_public_path__ + "img/男-高血压h.de62acf4.png";